export default "__VITE_ASSET__Qeq7BWCP__"